import { render } from "./PrintConfirmModal.vue?vue&type=template&id=1c2780bc"
import script from "./PrintConfirmModal.vue?vue&type=script&lang=js"
export * from "./PrintConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__